export const lobesModule = {
  id: "lobes",
  title: "Brain Lobes",
  sections: [
    {
      type: "text",
      content:
        "The circulatory system consists of two circuits: the pulmonary circuit (heart to lungs) and the systemic circuit (heart to body).",
      image: "/images/heart/circulation.jpg",
    },
    {
      type: "flipcard",
      front: "What are the two circulatory circuits?",
      back: "Pulmonary circuit (heart ↔ lungs) and Systemic circuit (heart ↔ body)",
    },
    {
      type: "question",
      text: "Which circuit carries blood to the lungs?",
      options: ["Systemic", "Pulmonary", "Coronary", "Portal"],
      correct: 1,
    },
  ],
};
